<template>
    <div class="photos-documents">
        <div id="elfinder"></div>
    </div>
</template>

<script>
export default {
    name: "PhotosAndDocuments",
    mounted() {
        $('#elfinder').elfinder({
            url: `${process.env.VUE_APP_API_URL}/elfinder/connector`,
            customData: {type: 'invoice'},
            height: 500,
            resizable: false,
            requestType: 'post',
            rememberLastDir: false,
            handlers: {
                init: function (event, elfinderInstance) {
                    elfinderInstance.id = 'elfinder'
                }
            },
            contextmenu: {
                navbar: [],
                cwd: ['reload'],
                files: ['download', 'rename']
            },
            uiOptions: {
                toolbar: [
                    ['back', 'forward'],
                    ['reload'],
                    ['home', 'up'],
                    ['mkdir', 'upload'],
                    ['info'],
                    ['quicklook'],
                    ['copy', 'cut', 'paste'],
                    ['rm'],
                    ['duplicate', 'rename', 'edit'],
                    ['view', 'sort']
                ]
            }
        });
    }
}
</script>

<style scoped>
.bg-violet {
    background-color: #5E00B6;
}

.photos-documents {
    width: 100%;
    min-width: 0;
    overflow-x: auto;
}

.photos-documents /deep/ .elfinder {
    min-width: 720px;
}

@media (max-width: 575.98px) {
    .photos-documents /deep/ .elfinder {
        min-width: 640px;
    }
}
</style>
